<span>
  X: {{ mapProjection?.x | formatNumber }} Y:
  {{ mapProjection?.y | formatNumber }}
</span>
